export default __webpack_public_path__ + "static/media/social-growth-rafiki.e54d6527.png";